import { LTPartType } from "../enum/PartType";

export const PartNames: { [key in LTPartType]: string } = {
  [LTPartType.AngleSection]: "Kantenschutz",
  [LTPartType.Corner]: "Ecke",
  [LTPartType.CornerBrace]: "L-Ecke",
  [LTPartType.Dish]: "Einbauschale",
  [LTPartType.Foot]: "Fuß",
  [LTPartType.Handle]: "Griff",
  [LTPartType.Hinge]: "Scharnier",
  [LTPartType.PianoHinge]: "Klavierband",
  [LTPartType.Lock]: "Schloss",
  [LTPartType.Pad]: "Schaumstoff",
  [LTPartType.Panel]: "Holz",
  [LTPartType.TrayPanel]: "Trennbretter",
  [LTPartType.Profile]: "Schließprofil",
  [LTPartType.RackRail]: "Rackschiene",
  [LTPartType.Roller]: "Rollen",
  [LTPartType.SlideRail]: "Rutschleiste",
  [LTPartType.TrolleyHandle]: "Trolley-Griff",
  [LTPartType.Volume]: "Inhalt",
  [LTPartType.Measurements]: "Bemaßung",
};
